import { NumberFormatter } from './helpers';

const Excel = require('exceljs');
var FileSaver = require('file-saver');
const excelExport = {}
const NUMERIC_DATA_TYPES = ['number', 'quantity', 'currency'];

export const excelConfig = {
    columns: [],
    fileName: `Excel_Export.xlsx`,
    headerRowStyle: {
        font: {
            name: 'Calibri',
            family: 2,
            size: 16,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        },
        alignment: { vertical: 'middle' },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF1E59A7' },
            bgColor: { argb: 'FF1E59A7' }
        }
    },
    borderStyle: {
        top: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        left: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        right: { style: 'thin', color: { argb: 'FFBDBDBD' } }
    },
    pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        margins: {
            left: 0.5, right: 0.1, top: 0.4, bottom: 0.3, header: 0.1, footer: 0.1
        },
        fitToPage: true,
        fitToHeight: 0
    },
    defaultHeaderRowHeight: 20,
    defaultDataRowHeight: 20,
    showFilterSection: false,
    filterSectionData: null,
    workSheetTitle: 'Sheet 1',
    headerFooter: {
        firstHeader: null,
        firstFooter: null
    }
}
//Filter Header Row
export const filterHeaderXlStyle = {
    alignment: { vertical: 'middle', horizontal: 'left' },
    font: { ame: 'Calibri', family: 2, size: 14, bold: true, color: { argb: 'FFFFFFFF' }, },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E59A7' }, bgColor: { argb: 'FF1E59A7' } },
    defaultRowHeight: 24
};

//Filter Data Row
export const filterHeaderXlDataStyle = {
    alignment: { vertical: 'middle', horizontal: 'left' },
    font: { ame: 'Calibri', family: 2, size: 14, bold: false, },
    defaultRowHeight: 24
}





export const processExcel = async (worksheet, config, dataRS = [], summaryData = []) => {
    try {

        let currentRow = config?.startRow ? config.startRow - 1 : worksheet.rowCount;

        // Default row height
        worksheet.properties.defaultRowHeight = config?.defaultRowHeight || 16;

        // Page setup
        if (config?.pageSetup) worksheet.pageSetup = config.pageSetup;
        if (config?.headerFooter) {
            worksheet.headerFooter.firstHeader = config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.firstFooter = config?.headerFooter?.firstFooter || null;
            worksheet.headerFooter.evenHeader = config?.headerFooter?.evenHeader || config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.evenFooter = config?.headerFooter?.evenFooter || config?.headerFooter?.firstFooter || null;
            worksheet.headerFooter.oddHeader = config?.headerFooter?.oddHeader || config?.headerFooter?.firstHeader || null;
            worksheet.headerFooter.oddFooter = config?.headerFooter?.oddFooter || config?.headerFooter?.firstFooter || null;
        }
        if (Array.isArray(config.sheetHeaderData)) {
            let currentRow = worksheet.rowCount + 1;
            let addedRow = worksheet.getRow(currentRow);
            let prevColSpan = 0;

            config.sheetHeaderData.forEach((sheetHeadingObj) => {
                let cellValue = '';
                if (sheetHeadingObj.caption) cellValue += sheetHeadingObj.caption;
                if (sheetHeadingObj.value) cellValue += ' ' + sheetHeadingObj.value;

                const cell = addedRow.getCell(prevColSpan + 1);
                cell.value = cellValue;
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: sheetHeadingObj.horizontal || 'left'
                };
                cell.font = {
                    bold: true,
                    size: sheetHeadingObj.size || 16
                };

                if (sheetHeadingObj.borderStyle) {
                    cell.border = config.borderStyle;
                }

                if (sheetHeadingObj.colSpan) {
                    const startCol = prevColSpan + 1;
                    const endCol = startCol + sheetHeadingObj.colSpan - 1;

                    worksheet.mergeCells(currentRow, startCol, currentRow, endCol);

                    if (sheetHeadingObj.newRow) {
                        addedRow.commit();
                        currentRow++;
                        addedRow = worksheet.getRow(currentRow);
                        prevColSpan = 0;
                    } else {
                        prevColSpan = endCol;
                    }
                }
            });

            addedRow.commit();

            // spacer row
            const spacerRow = worksheet.getRow(currentRow + 1);
            spacerRow.commit();
        }

        // If Report Filter Section To Be Added
        if (config.showFilterSection) {
            if (config?.filterSectionData) {
                const filterData = config?.filterSectionData?.filterData || [];
                const filterHeaderStyle = config?.filterSectionData?.filterHeaderXlStyle || {};
                const filterDataStyle = config?.filterSectionData?.filterHeaderXlDataStyle || {};
                if (Array.isArray(filterData)) {
                    filterData.forEach((dataObj, index) => {
                        let addedRow = worksheet.addRow([]);
                        // Filters Header Row
                        if (dataObj?.columns) {
                            if (Array.isArray(dataObj.columns)) {
                                let prevColSpan = 0;
                                dataObj.columns.forEach((col, index) => {
                                    if (col?.header) {
                                        let cell = addedRow.getCell(prevColSpan + 1);
                                        cell.value = col.header;
                                        if (filterHeaderStyle?.alignment)
                                            cell.alignment = filterHeaderStyle.alignment;
                                        if (filterHeaderStyle?.font)
                                            cell.font = filterHeaderStyle.font;
                                        if (filterHeaderStyle?.fill)
                                            cell.fill = filterHeaderStyle.fill;
                                        cell.border = config.borderStyle;
                                        if (col?.xlCol?.colSpan) {
                                            const currentRowIdx = worksheet.rowCount;
                                            const startColSpanIndex = prevColSpan + 1;
                                            const endColSpanIndex = startColSpanIndex + col.xlCol.colSpan - 1;
                                            worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                            prevColSpan = endColSpanIndex;
                                        }
                                    }
                                });
                            }
                        }
                        addedRow.height = filterHeaderStyle?.defaultRowHeight || 24;
                        addedRow.commit();
                        // Filters Data Row
                        if (dataObj?.columns && dataObj.data) {
                            let addedRow = worksheet.addRow([]);
                            const filterRowData = dataObj.data[0];
                            if (Array.isArray(dataObj.columns)) {
                                let prevColSpan = 0;
                                dataObj.columns.forEach((col, index) => {
                                    if (col?.dataKey) {
                                        let cell = addedRow.getCell(prevColSpan + 1);
                                        if (filterRowData.hasOwnProperty(col.dataKey))
                                            cell.value = filterRowData[col.dataKey];
                                        else
                                            cell.value = '';


                                        if (filterDataStyle?.alignment)
                                            cell.alignment = filterDataStyle.alignment;
                                        if (filterDataStyle?.font)
                                            cell.font = filterDataStyle.font;
                                        if (filterDataStyle?.fill)
                                            cell.fill = filterDataStyle.fill;
                                        cell.border = config.borderStyle;
                                        if (col?.xlCol?.colSpan) {
                                            const currentRowIdx = worksheet.rowCount;
                                            const startColSpanIndex = prevColSpan + 1;
                                            const endColSpanIndex = startColSpanIndex + col.xlCol.colSpan - 1;
                                            worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                            prevColSpan = endColSpanIndex;
                                        }
                                    }
                                });
                            }
                            addedRow.height = filterDataStyle?.defaultRowHeight || 24;
                            addedRow.commit();
                        }
                    });
                }
            }
            // Empty Row After Filter Seciton
            const addedRow = worksheet.addRow([]);
            addedRow.commit();
            const newRow = worksheet.addRow([]);
            newRow.commit();
        }
        if (config.showHeader) {
            if (Array.isArray(config.columns) && config.columns.length > 0) {
                // caption
                if (config.columnsCaption) {
                    let addedRow = worksheet.addRow([]);
                    let cell = addedRow.getCell(1);
                    cell.value = (config.columnsCaption);
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                    cell.font = { color: { argb: "00000000" } };
                    const currentRowIdx = worksheet.rowCount;
                    worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);


                    if (addedRow) {
                        if (config.hasOwnProperty('dataRowStyle')) {
                            if (config.dataRowStyle.hasOwnProperty('font')) {
                                addedRow.font = config.dataRowStyle.font;
                            }
                        }
                        addedRow.height = config?.defaultDataRowHeight || 16;
                        addedRow.commit();
                    }
                }


                // let row = [];
                let previColSpan = 0;
                let addedRow = worksheet.addRow([]);
                config.columns.forEach((col, index) => {
                    if (col.hasOwnProperty('colHeader')) {
                        let cell = addedRow.getCell(index + 1);
                        cell.value = col.colHeader;


                        if (config?.headerRowStyle?.fill && config.headerRowStyle.fill !== '') {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: config.headerRowStyle.fill },
                                bgColor: { argb: config.headerRowStyle.fill }
                            };
                        }
                        if (col.colHeader !== '') {
                            cell.border = config.borderStyle;
                        }
                        if (config?.headerRowStyle?.font)
                            cell.font = { size: config.headerRowStyle.font, bold: config.headerRowStyle.bold || false, color: { argb: config?.headerRowStyle?.fill && config.headerRowStyle.fill !== '' ? 'FFFFFFFF' : '00000000' }, };
                        if (col.hasOwnProperty('xlCol')) {
                            if (col.xlCol.hasOwnProperty('colSpan')) {
                                const currentRowIdx = worksheet.rowCount;
                                const startColSpanIndex = previColSpan + 1;
                                const endColSpanIndex = startColSpanIndex + col.xlCol.colSpan - 1;
                                worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                previColSpan = endColSpanIndex;
                            }
                            if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                } else {
                                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                }
                            }
                            if (col.xlCol.hasOwnProperty('width') && col.xlCol.width > 0) {
                                let column = worksheet.getColumn(index + 1);
                                column.width = col.xlCol.width;
                            }
                        }
                    }
                });
                addedRow.height = config?.defaultHeaderRowHeight || 20;
                addedRow.commit();
            }
        }
        if (Array.isArray(config.columns) && config.columns.length > 0) {
            if (dataRS.length > 0) {
                for (let data of dataRS) {
                    let addedRow = null;
                    if (data.isSubHeadingRow) {
                        if (Array.isArray(data?.subHeadingData)) {
                            let addedRow = worksheet.addRow([]); // Create a single row for all subHeadingData
                            let prevColSpan = 0;

                            data.subHeadingData.forEach((subHeadingObj) => {
                                let cellValue = '';
                                if (subHeadingObj.hasOwnProperty('caption'))
                                    cellValue += subHeadingObj.caption;
                                if (subHeadingObj.hasOwnProperty('value'))
                                    cellValue += ' ' + subHeadingObj.value;

                                let cell = addedRow.getCell(prevColSpan + 1);
                                cell.value = cellValue;
                                cell.alignment = { vertical: 'middle', horizontal: subHeadingObj.align || 'left' };
                                cell.font = { bold: true };
                                cell.border = config.borderStyle;

                                if (data?.rowColor?.argb) {
                                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: data.rowColor.argb }, bgColor: { argb: '000000' } };
                                }

                                if (subHeadingObj.hasOwnProperty('colSpan')) {
                                    const startColSpanIndex = prevColSpan + 1;
                                    const endColSpanIndex = startColSpanIndex + subHeadingObj.colSpan - 1;
                                    worksheet.mergeCells(addedRow.number, startColSpanIndex, addedRow.number, endColSpanIndex);
                                    prevColSpan = endColSpanIndex; // Update previous column span
                                } else {
                                    prevColSpan += 1; // Move to the next column
                                }
                            });
                        }
                    } else if (data.isTotalRow) {
                        let addedRow = worksheet.addRow([]);
                        config.columns.forEach((col, index) => {
                            let cell = addedRow.getCell(index + 1);
                            if (col.hasOwnProperty('field')) {
                                if (data.hasOwnProperty(col.field)) {
                                    if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                        if (col.xlCol.dataType === 'currency')
                                            cell.value = NumberFormatter(data[col.field], 1);
                                        if (col.xlCol.dataType === 'quantity')
                                            cell.value = NumberFormatter(data[col.field], 2);
                                        if (col.xlCol.dataType === 'number')
                                            cell.value = data[col.field];
                                        cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                    } else {
                                        cell.value = data[col.field];
                                        cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                    }
                                }
                            }


                            if (1) {
                                let cell = addedRow.getCell(index + 1);
                                cell.border = config.borderStyle;
                                cell.font = { bold: true };
                                if (data?.rowColor?.argb) {
                                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' }, bgColor: { argb: '000000' } };
                                }
                            }
                        });
                        let cell = addedRow.getCell(1);
                        cell.value = data.totalCaption;
                        cell.alignment = { vertical: 'middle', horizontal: data.totalCaptionAllignment !== undefined ? data.totalCaptionAllignment : 'right' };
                        if (data.hasOwnProperty('colSpan')) {
                            const currentRowIdx = worksheet.rowCount;
                            worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, data.colSpan);
                        }
                    } else if (data.isHeaderRow) {
                        if (Array.isArray(config.columns) && config.columns.length > 0) {
                            // caption
                            if (config.columnsCaption) {
                                let addedRow = worksheet.addRow([]);
                                let cell = addedRow.getCell(1);
                                cell.value = (config.columnsCaption);
                                cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                cell.font = { color: { argb: "00000000" } };
                                const currentRowIdx = worksheet.rowCount;
                                worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);


                                if (addedRow) {
                                    if (config.hasOwnProperty('dataRowStyle')) {
                                        if (config.dataRowStyle.hasOwnProperty('font')) {
                                            addedRow.font = config.dataRowStyle.font;
                                        }
                                    }
                                    addedRow.height = config?.defaultDataRowHeight || 16;
                                    addedRow.commit();
                                }
                            }


                            // let row = [];
                            let addedRow = worksheet.addRow([]);
                            config.columns.forEach((col, index) => {
                                if (col.hasOwnProperty('colHeader')) {
                                    let cell = addedRow.getCell(index + 1);
                                    cell.value = col.colHeader;
                                    if (config?.headerRowStyle?.font)
                                        cell.font = config.headerRowStyle.font;
                                    if (config?.headerRowStyle?.fill)
                                        cell.fill = config.headerRowStyle.fill;


                                    cell.border = config.borderStyle;
                                    if (col.hasOwnProperty('xlCol')) {
                                        if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                            if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                            } else {
                                                cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                            }
                                        }
                                        if (col.xlCol.hasOwnProperty('width') && col.xlCol.width > 0) {
                                            let column = worksheet.getColumn(index + 1);
                                            column.width = col.xlCol.width;
                                        }
                                    }
                                }
                            });
                            addedRow.height = config?.defaultHeaderRowHeight || 20;
                            addedRow.commit();
                        }
                    } else if (data.isNoDataRow && config.showEmptyRow) {
                        let addedRow = worksheet.addRow([]);
                        let cell = addedRow.getCell(1);
                        cell.value = data.rowCaption;
                        cell.alignment = { vertical: 'middle', horizontal: 'left' };
                        cell.font = { color: { argb: "ffff0000" } };
                        const currentRowIdx = worksheet.rowCount;
                        worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);
                    } else {
                        addedRow = worksheet.addRow([]);
                        config.columns.forEach((col, index) => {
                            let cell = addedRow.getCell(index + 1);
                            if (col.hasOwnProperty('field')) {
                                if (data.hasOwnProperty(col.field)) {
                                    cell.value = data[col.field];
                                    if (col.hasOwnProperty('xlCol')) {
                                        if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                            if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                                if (col.xlCol.dataType === 'currency')
                                                    cell.value = NumberFormatter(data[col.field], 2);
                                                if (col.xlCol.dataType === 'quantity')
                                                    cell.value = NumberFormatter(data[col.field], 3);
                                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                            } else {
                                                cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                                            }
                                        }
                                    }
                                } else {
                                    cell.value = '';
                                }
                                cell.border = config.borderStyle;
                                if (col.xlCol.hasOwnProperty('width') && col.xlCol.width > 0) {
                                    let column = worksheet.getColumn(index + 1);
                                    column.width = col.xlCol.width;
                                }
                            }
                        });
                    }


                    if (addedRow) {
                        if (config.hasOwnProperty('dataRowStyle')) {
                            if (config.dataRowStyle.hasOwnProperty('font')) {
                                addedRow.font = config.dataRowStyle.font;
                            }
                        }
                        addedRow.height = config?.defaultDataRowHeight || 16;
                        addedRow.commit();
                    }
                }
            }
            else {
                let addedRow = worksheet.addRow([]);
                let cell = addedRow.getCell(1);
                cell.value = "No Records found";
                cell.alignment = { vertical: 'middle', horizontal: 'middle' };
                cell.font = { color: { argb: "ffff0000" } };
                const currentRowIdx = worksheet.rowCount;
                worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);


                if (addedRow) {
                    if (config.hasOwnProperty('dataRowStyle')) {
                        if (config.dataRowStyle.hasOwnProperty('font')) {
                            addedRow.font = config.dataRowStyle.font;
                        }
                    }
                    addedRow.height = config?.defaultDataRowHeight || 16;
                    addedRow.commit();
                }
                // Empty Row After Table Seciton
                const addRow = worksheet.addRow([]);
                addRow.commit();
                const newRow = worksheet.addRow([]);
                newRow.commit();
            }
        }


        // If Report Summary Section To Be Added
        if (config.showSummarySection) {
            // summary caption
            if (config.summaryCaption) {
                let addedRow = worksheet.addRow([]);
                let cell = addedRow.getCell(1);
                cell.value = (config.summaryCaption);
                cell.alignment = { vertical: 'middle', horizontal: 'left' };
                cell.font = { color: { argb: "00000000" }, bold: true };
                const currentRowIdx = worksheet.rowCount;
                worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);


                if (addedRow) {
                    if (config.hasOwnProperty('dataRowStyle')) {
                        if (config.dataRowStyle.hasOwnProperty('font')) {
                            addedRow.font = config.dataRowStyle.font;
                        }
                    }
                    addedRow.height = config?.defaultDataRowHeight || 16;
                    addedRow.commit();
                }
            }


            if (Array.isArray(config.summaryColumns) && config.summaryColumns.length > 0) {
                // let row = [];
                let addedRow = worksheet.addRow([]);
                config.summaryColumns.forEach((col, index) => {
                    if (col.hasOwnProperty('colHeader')) {
                        let cell = addedRow.getCell(index + 1);
                        cell.value = col.colHeader;
                        if (config?.headerRowStyle?.font)
                            cell.font = config.headerRowStyle.font;
                        if (config?.headerRowStyle?.fill)
                            cell.fill = config.headerRowStyle.fill;
                        if (config?.headerRowStyle?.bold)
                            cell.font = { bold: config.headerRowStyle.bold };


                        cell.border = config.borderStyle;
                        if (col.hasOwnProperty('xlCol')) {
                            if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                } else if (col.xlCol.dataType === 'center') {
                                    cell.alignment = { vertical: 'middle', horizontal: 'middle' };
                                } else {
                                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                }
                            }
                            if (col.xlCol.hasOwnProperty('width') && col.xlCol.width > 0) {
                                let column = worksheet.getColumn(index + 1);
                                column.width = col.xlCol.width;
                            }
                        }
                    }
                });
                addedRow.height = config?.defaultHeaderRowHeight || 20;
                addedRow.commit();
            }


            if (Array.isArray(config.summaryColumns) && config.summaryColumns.length > 0) {
                if (summaryData.length > 0) {
                    for (let data of summaryData) {
                        let addedRow = null;
                        if (data.isDataRow) {
                            addedRow = worksheet.addRow([]);
                            config.summaryColumns.forEach((col, index) => {
                                let cell = addedRow.getCell(index + 1);
                                if (col.hasOwnProperty('field')) {
                                    if (data.hasOwnProperty(col.field)) {
                                        cell.value = data[col.field];
                                        if (col.hasOwnProperty('xlCol')) {
                                            if (col.xlCol.hasOwnProperty('dataType') && col.xlCol.dataType !== '') {
                                                if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                                    if (col.xlCol.dataType === 'currency')
                                                        cell.value = NumberFormatter(data[col.field], 1);
                                                    if (col.xlCol.dataType === 'quantity')
                                                        cell.value = NumberFormatter(data[col.field], 2);
                                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                                } else {
                                                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                                }
                                            }
                                        }
                                    } else {
                                        cell.value = '';
                                    }
                                    cell.border = config.borderStyle;
                                }
                            });
                        } else if (data.isSubHeadingRow) {
                            if (Array.isArray(data?.subHeadingData)) {
                                let addedRow = worksheet.addRow([]);
                                let prevColSpan = 0;
                                data.subHeadingData.forEach((subHeadingObj, index) => {
                                    let cellValue = '';
                                    if (subHeadingObj.hasOwnProperty('caption'))
                                        cellValue += subHeadingObj.caption;
                                    if (subHeadingObj.hasOwnProperty('value'))
                                        cellValue += ' ' + subHeadingObj.value;
                                    let cell = addedRow.getCell(prevColSpan + 1);
                                    cell.value = cellValue;
                                    cell.alignment = { vertical: 'middle', horizontal: `${subHeadingObj.align || 'left'}` };
                                    cell.font = { bold: true };
                                    if (data?.rowColor?.argb) {
                                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5FAFE' }, bgColor: { argb: '000000' } };
                                    }
                                    cell.border = config.borderStyle;
                                    if (subHeadingObj.hasOwnProperty('colSpan')) {
                                        const currentRowIdx = worksheet.rowCount;
                                        const startColSpanIndex = prevColSpan + 1;
                                        const endColSpanIndex = startColSpanIndex + subHeadingObj.colSpan - 1;
                                        worksheet.mergeCells(currentRowIdx, startColSpanIndex, currentRowIdx, endColSpanIndex);
                                        prevColSpan = startColSpanIndex + subHeadingObj.colSpan - 1;
                                    }
                                });
                            }
                        } else if (data.isTotalRow) {
                            let addedRow = worksheet.addRow([]);
                            config.summaryColumns.forEach((col, index) => {
                                let cell = addedRow.getCell(index + 1);
                                if (col.hasOwnProperty('field')) {
                                    if (data.hasOwnProperty(col.field)) {
                                        if (NUMERIC_DATA_TYPES.indexOf(col.xlCol.dataType) !== -1) {
                                            if (col.xlCol.dataType === 'currency')
                                                cell.value = NumberFormatter(data[col.field], 2);
                                            if (col.xlCol.dataType === 'quantity')
                                                cell.value = NumberFormatter(data[col.field], 3);
                                            if (col.xlCol.dataType === 'number')
                                                cell.value = data[col.field];
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        } else {
                                            cell.value = data[col.field];
                                            cell.alignment = { vertical: 'middle', horizontal: 'left' };
                                        }
                                    }
                                }


                                if (1) {
                                    let cell = addedRow.getCell(index + 1);
                                    if (data?.rowColor?.argb) {
                                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE4EBF5' }, bgColor: { argb: '000000' } };
                                    }
                                    cell.border = config.borderStyle;
                                    cell.font = { bold: true };
                                }
                            });
                            let cell = addedRow.getCell(1);
                            cell.value = data.totalCaption;
                            cell.alignment = { vertical: 'middle', horizontal: data.totalCaptionAllignment !== undefined ? data.totalCaptionAllignment : 'right' };
                            if (data.hasOwnProperty('colSpan')) {
                                const currentRowIdx = worksheet.rowCount;
                                worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, data.colSpan);
                            }
                        } else if (data.isNoDataRow) {
                            let addedRow = worksheet.addRow([]);
                            let cell = addedRow.getCell(1);
                            cell.value = data.rowCaption;
                            cell.alignment = { vertical: 'middle', horizontal: 'left' };
                            cell.font = { color: { argb: "ffff0000" } };
                            const currentRowIdx = worksheet.rowCount;
                            worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.summaryColumns.length);
                        }


                        if (addedRow) {
                            if (config.hasOwnProperty('dataRowStyle')) {
                                if (config.dataRowStyle.hasOwnProperty('font')) {
                                    addedRow.font = config.dataRowStyle.font;
                                }
                            }
                            addedRow.height = config?.defaultDataRowHeight || 16;
                            addedRow.commit();
                        }
                    }
                }
                else {
                    let addedRow = worksheet.addRow([]);
                    let cell = addedRow.getCell(1);
                    cell.value = "No Records found";
                    cell.alignment = { vertical: 'middle', horizontal: 'middle' };
                    cell.font = { color: { argb: "ffff0000" } };
                    const currentRowIdx = worksheet.rowCount;
                    worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, config.columns.length);


                    if (addedRow) {
                        if (config.hasOwnProperty('dataRowStyle')) {
                            if (config.dataRowStyle.hasOwnProperty('font')) {
                                addedRow.font = config.dataRowStyle.font;
                            }
                        }
                        addedRow.height = config?.defaultDataRowHeight || 16;
                        addedRow.commit();
                    }
                }
                // Empty Row After summary table Seciton
                const addedRow = worksheet.addRow([]);
                addedRow.commit();
            }
        }
        return { worksheet, currentRow };

    } catch (err) {
        console.log(err);
        throw err;
    }
}

